module.exports = __webpack_public_path__ + "assets/mastercard.52882103.svg";